import { useCallback, useState } from 'react';
import { supabase } from '../lib/supabase';

const BUCKET = 'fotos-looks';

export function useLookUpload() {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const upload = useCallback(async (lookId: number, file: File): Promise<string | null> => {
    setUploading(true);
    setError(null);
    try {
      const ext = file.name.split('.').pop() || 'jpg';
      const path = `${lookId}_${Date.now()}.${ext}`;

      const { error: upErr } = await supabase
        .storage
        .from(BUCKET)
        .upload(path, file, {
          cacheControl: '3600',
          upsert: true,
        });

      if (upErr) {
        setError(upErr.message);
        return null;
      }

      const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
      return data?.publicUrl ?? null;
    } catch {
      setError('Error al subir la imagen');
      return null;
    } finally {
      setUploading(false);
    }
  }, []);

  return { upload, uploading, error };
}